import React from "react";
import PaymentRequestButton from "./PaymentRequestButton";

const ApplePayButton = (props) => {
  return <PaymentRequestButton {...props} provider="apple" />;
};

export default ApplePayButton;